const termsContent = {
    title: "Terms of Services",
    breadcrumb: [
        { name: "إتصل بنا", className: "breadcrumb-item", link: "/" },
        { name: "Page", className: "breadcrumb-item", link: "#" },
        { name: "Terms", className: "breadcrumb-item active" }
    ],
    buttons: [
        { to: "/contact-us", label: "Contact Us", className: "btn btn-primary mt-2 me-2" },
        { to: "/services", label: "Services", className: "btn btn-outline-primary mt-2" },
    ],
    welcome: {
        title: "Welcome to Subul Contracting :",
        content: "Discover the best in heating, ventilation, and air conditioning services at Subul Contracting. We are dedicated to providing unmatched comfort solutions for your indoor spaces.",
    },
    commitment: {
        title: "Our Service Commitment :",
        content: "At Subul Contracting, we pledge to provide HVAC services that are reliable and efficient, specifically tailored to meet your unique needs. Our unwavering commitment is to enhance the performance and lifespan of your HVAC systems, ensuring your indoor comfort year-round.",
    },
    restrictions: {
        title: "Service Restrictions :",
        content: "To ensure the quality and safety of our HVAC services, you are specifically restricted from engaging in the following activities:",
        listItems: [
            "Attempting to repair HVAC systems without proper training and certification.",
            "Modifying or tampering with HVAC components, including internal wiring and refrigerant lines.",
            "Installing non-approved aftermarket parts or components that may compromise system efficiency.",
            "Disassembling or cleaning internal HVAC components without professional guidance.",
            "Neglecting regular maintenance schedules, leading to potential system failures.",
            "Using unauthorized refrigerants or attempting to recharge the system without proper certification.",
        ],
    },
    faq: {
        title: "Users Question & Answer :",
        faqItems: [
            {
                question: "How often should I service my HVAC system?",
                answer: "It is recommended to service your HVAC system annually to ensure optimal performance and longevity.",
            },
            {
                question: "What are signs that my HVAC system needs repair?",
                answer: "Signs include unusual noises, reduced airflow, and inconsistent temperature control.",
            },
            {
                question: "How can I improve the energy efficiency of my HVAC system?",
                answer: "To enhance energy efficiency, regularly clean or replace air filters and consider upgrading to a programmable thermostat.",
            },
            {
                question: "What is the lifespan of an HVAC system?",
                answer: "The average lifespan of an HVAC system is around 15 to 20 years, depending on maintenance and usage.",
            },
            // Add more FAQ items as needed
        ],
    },
};

export { termsContent }